/**
 * Model to hold Claim data from identity
 */
import { IdentityUser } from '@reg/shared/model';

export class IdentityClaim {
    public static STATUS_APPROVED: string = 'approved';
    public static STATUS_DENIED: string = 'denied';
    public static STATUS_PENDING: string = 'pending';
    public static STATUS_INVITED: string = 'invited';
    public static RESOURCE_TYPE_TEAM: string = 'team';
    public static RESOURCE_TYPE_ASSESSOR: string = 'assessor';

    public id: string = null;
    public role: string = null;
    public resourceType: string = null;
    public resourceId: string = null;
    public user: IdentityUser = new IdentityUser();
    public userEmail: string;
    public status: string = null;

    public isApproved(): boolean {
        return (this.status || '').toLowerCase() === IdentityClaim.STATUS_APPROVED;
    }

    public isDeclined(): boolean {
        return (this.status || '').toLowerCase() === IdentityClaim.STATUS_DENIED;
    }

    public isInvited(): boolean {
        return (this.status || '').toLowerCase() === IdentityClaim.STATUS_INVITED;
    }

    public clone(): IdentityClaim {
        const clone: IdentityClaim = new IdentityClaim();
        clone.id = this.id;
        clone.role = this.role;
        clone.resourceType = this.resourceType;
        clone.resourceId = this.resourceId;
        clone.status = this.status;
        clone.user = this.user && this.user.clone();
        clone.userEmail = this.userEmail;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'claim';
        json.data.id = this.id;
        json.data.attributes = {};

        if (this.id) {
            // Update claim
            json.data.attributes.role = this.role;
            json.data.attributes.status = this.status;
        } else {
            // Create claim
            json.data.attributes.role = this.role;
            json.data.attributes.resourceType = this.resourceType;
            json.data.attributes.resourceId = this.resourceId;
            json.data.attributes.status = this.status;
            json.data.attributes.userEmail = this.userEmail;
        }

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any, included: any[] = null): IdentityClaim {
        const data: any = json['data'] || json;
        const attrs: any = data.attributes || [];
        included = included || json['included'] || [];

        this.id = data.id;
        this.role = attrs.role;
        this.resourceType = attrs.resourceType;
        this.resourceId = attrs.resourceId;
        this.status = attrs.status;
        this.userEmail = attrs.userEmail;

        // Fill user from relationships if it exists
        const user: any = included.filter((i: any) => i['type'] === 'user' && i['id'] === attrs.userId)[0];

        if (user) {
            this.user = (new IdentityUser(attrs.userId)).deserialize(user, included);
        } else {
            this.user = new IdentityUser(attrs.userId);
        }

        return this;
    }
}
